import React from 'react';
import Icon from '../../../components/AppIcon';

const AgentWorkloadCard = () => {
  const agents = [
    {
      id: 1,
      name: "Sarah Johnson",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150",
      activeTickets: 8,
      capacity: 12,
      avgResolution: "2.4h",
      satisfaction: 4.8,
      status: "online"
    },
    {
      id: 2,
      name: "Michael Chen",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150",
      activeTickets: 11,
      capacity: 15,
      avgResolution: "3.1h",
      satisfaction: 4.6,
      status: "online"
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150",
      activeTickets: 6,
      capacity: 10,
      avgResolution: "1.8h",
      satisfaction: 4.9,
      status: "busy"
    },
    {
      id: 4,
      name: "David Kim",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150",
      activeTickets: 9,
      capacity: 12,
      avgResolution: "2.7h",
      satisfaction: 4.7,
      status: "online"
    },
    {
      id: 5,
      name: "Lisa Thompson",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150",
      activeTickets: 4,
      capacity: 8,
      avgResolution: "2.1h",
      satisfaction: 4.8,
      status: "away"
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'online': return 'bg-success';
      case 'busy': return 'bg-warning';
      case 'away': return 'bg-text-secondary';
      default: return 'bg-text-secondary';
    }
  };

  const getCapacityColor = (active, capacity) => {
    const percentage = (active / capacity) * 100;
    if (percentage >= 90) return 'text-error';
    if (percentage >= 75) return 'text-warning';
    return 'text-success';
  };

  const getCapacityBg = (active, capacity) => {
    const percentage = (active / capacity) * 100;
    if (percentage >= 90) return 'bg-error';
    if (percentage >= 75) return 'bg-warning';
    return 'bg-success';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 dashboard-fade-in">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
          <Icon name="Users" size={20} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-text-primary">Agent Workload</h3>
          <p className="text-sm text-text-secondary">Current capacity and performance</p>
        </div>
      </div>

      <div className="space-y-4">
        {agents.map((agent) => {
          const capacityPercentage = (agent.activeTickets / agent.capacity) * 100;
          
          return (
            <div key={agent.id} className="p-4 bg-background rounded-lg border border-border">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <div className="relative">
                    <img
                      src={agent.avatar}
                      alt={agent.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div className={`absolute -bottom-1 -right-1 w-4 h-4 ${getStatusColor(agent.status)} rounded-full border-2 border-background`} />
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-text-primary">{agent.name}</h4>
                    <p className="text-xs text-text-secondary capitalize">{agent.status}</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-2">
                  <Icon name="Star" size={14} className="text-warning fill-current" />
                  <span className="text-sm font-medium text-text-primary">{agent.satisfaction}</span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-3">
                <div>
                  <p className="text-xs text-text-secondary mb-1">Active Tickets</p>
                  <p className={`text-sm font-semibold ${getCapacityColor(agent.activeTickets, agent.capacity)}`}>
                    {agent.activeTickets}/{agent.capacity}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-text-secondary mb-1">Avg Resolution</p>
                  <p className="text-sm font-semibold text-text-primary">{agent.avgResolution}</p>
                </div>
              </div>

              <div className="space-y-2">
                <div className="flex items-center justify-between text-xs">
                  <span className="text-text-secondary">Capacity</span>
                  <span className={`font-medium ${getCapacityColor(agent.activeTickets, agent.capacity)}`}>
                    {capacityPercentage.toFixed(0)}%
                  </span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full transition-all duration-300 ${getCapacityBg(agent.activeTickets, agent.capacity)}`}
                    style={{ width: `${Math.min(capacityPercentage, 100)}%` }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <p className="text-2xl font-bold text-text-primary">5</p>
            <p className="text-xs text-text-secondary">Active Agents</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-text-primary">38</p>
            <p className="text-xs text-text-secondary">Total Tickets</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentWorkloadCard;